const env = process.env.NODE_ENV
const name = process.env.VUE_APP_NAME
function getDifAddress (name) {
  let apiUrl = null
  switch (name) {
    case 'defalut':
      apiUrl = env === 'production' ? 'https://singapore.fooyotravel.com/' : 'https://singapore-staging.fooyotravel.com/'
      break
    case 'twg':
      apiUrl = env === 'production' ? 'https://twgtea.fooyotravel.com/' : 'https://twgtea-staging.fooyotravel.com/'
      break
  }
  return apiUrl
}
const apiUrl = getDifAddress(name)
export default apiUrl
